<template>
  <div>
    <div style="display: flex; justify-content: space-between;" class="mb-2">
      <span>{{ $t('network.user.contentLanguage') }}</span>&nbsp;
      <span id="select-preferred-lang" class="text-primary text-end pointer" @click="showEditFeedLanguageModal = !showEditFeedLanguageModal">
        {{ $t('network.user.update') }}
      </span>
    </div>
    <div style="background-color: #D9D9D9;" class="rounded p-2">
      <span v-if="myPreferredLanguages.length != 0" class="me-2" v-html="myPreferredLanguages.length + ' selected languages'"></span>
      <span v-else class="me-2" v-html="'All languages'"></span>
      <span v-if="myPreferredLanguages.length != 0 && readOnly" role="button" @click="removeAllPreferredLanguages()">
        <i class="fas fa-times ms-2 text-danger"></i>
      </span>
    </div>

    <b-modal v-model="showEditFeedLanguageModal" hide-footer hide-header no-close-on-esc no-close-on-backdrop size="lg">
      <span role="button" class="close float-end fs-4 mt-n2 me-n1" @click.prevent="showEditFeedLanguageModal = false, showAllLanguages = false">
        <span aria-hidden="true"><i class="fa fa-times"></i></span>
      </span>
        <h4 class="mb-4">{{ $t('network.user.preferredLanguages') }}</h4>
        <div class="row">
          <div v-for="language in currentFilterLanguages" :key="language.id" class="col-md-4 p-0">
            <div class="form-check">
              <input
                :id="'ex-check' + language.id"
                :data-test="'ex-check' + language.id"
                type="checkbox"
                :value="language"
                :checked="language.selected"
                class="form-check-input"
                @change="updatePreferredLanguage(language, $event.target.checked)"
              />
              <label :for="'ex-check' + language.id" class="form-check-label">{{ language.language }}</label>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12 p-0">
            <a href="#" @click.prevent="showAllLanguages = !showAllLanguages">
              {{ showAllLanguages ? 'See top languages...' : 'See all languages...' }}
            </a>
          </div>
        </div>
    </b-modal>
  </div>
</template>
<script>
import { orderBy, take } from 'lodash';

export default {
  props: {
    // indicates whether this input component will allow or not allow changes to selected lagnuages
    readOnly: {
      type: Boolean,
      default: false,
    },
    updateMyPreferredLanguages: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // flags for view modes:
      showEditFeedLanguageModal: false, // flag to control whether the full (edit) dialog is showing on screen
      showAllLanguages: false, // flag to indicate the user wants to see all or just the "top" language
    };
  },
  computed: {
    // This will return either the top languages or all language, depending on the user's choice (based on `showAllLanguages` boolean)
    currentFilterLanguages() {
      if (this.showAllLanguages) {
        return orderBy(this.languages, ['language'], ['asc']);
      } else {
        return this.topLanguages;
      }
    },
    // returns the 5 most used languages in the system.
    // + it will include any selected languages.
    topLanguages() {
      // if the user is logged in, we not only need to list the top used languages, but we should INCLUDE any language they have already selected.
      // In otherwords, selected languages by the user MUST always be visible

      // first order everything by selected, total
      let numSelected = this.myPreferredLanguages.length;
      return take(orderBy(this.allLanguagesWithUserPreferenceIncluded, ['selected'], ['desc']), Math.max(numSelected, 6));
    },
    allLanguagesWithUserPreferenceIncluded() {
      return this.$store.getters['content_language/allLanguagesWithUserPreferenceIncluded'];
    },
    languages() {
      return this.$store.state.content_language.languages;
    },
    myPreferredLanguages() {
      return this.$store.state.content_language.myPreferredLanguages;
    },
  },
  mounted() {
    // we need to load all languages and my preferred languages (if the user is signed in)
    this.$store.dispatch('content_language/loadLanguages'); // load all
    if (this.$auth.user) {
      // load preferred language for logged in users only
      this.$store.dispatch('content_language/loadMyPreferredLanguages');
    }
  },
  methods: {
    updatePreferredLanguage(language, event) {
      if (event) {
        this.$store.commit('content_language/ADD_TO_MY_PREFERRED_LANGUAGES', language);
      } else {
        this.$store.commit('content_language/REMOVE_FROM_MY_PREFERRED_LANGUAGES', language);
      }
      this.axios.post('/auth/update-feed-language', this.myPreferredLanguages);
    },
  },
};
</script>